import React from 'react';
import {
  TopBar,
  TopBarSection,
  ImageNameButton,
  ZoomControlGroup,
  ZoomButton,
  ZoomValue,
} from '../imageCanvasStyles';
import { WorkflowIndicator } from './WorkflowIndicator';

const TopCanvasToolbar = ({
  theme,
  selectedTheme,
  imageName,
  zoom,
  onZoomIn,
  onZoomOut,
  currentStep,
}) => {
  const shared = { theme, $selectedTheme: selectedTheme };

  return (
    <TopBar {...shared}>
      <TopBarSection $flex='1' $gap='0.5rem'>
        <ImageNameButton {...shared}>
          {imageName}
          <span>&#9662;</span>
        </ImageNameButton>
      </TopBarSection>

      <TopBarSection $justify='center'>
        <WorkflowIndicator
          theme={theme}
          selectedTheme={selectedTheme}
          currentStep={currentStep}
        />
      </TopBarSection>

      <TopBarSection $flex='1' $justify='flex-end'>
        <ZoomControlGroup {...shared}>
          <ZoomButton {...shared} onClick={onZoomOut} title='Zoom out'>&#8722;</ZoomButton>
          <ZoomValue {...shared}>{zoom}%</ZoomValue>
          <ZoomButton {...shared} onClick={onZoomIn} title='Zoom in'>&#43;</ZoomButton>
        </ZoomControlGroup>
      </TopBarSection>
    </TopBar>
  );
};

export { TopCanvasToolbar };
